<span class="badge text-uppercase px-2 py-1" [ngClass]="look?.cls ?? ''">
    {{ look?.label }}
    <i class="ms-1 bi" [ngClass]="look?.icon ?? ''"></i>
</span>
